const changes = [
  {
    "type": "feature",
    "description": "User now can rename their profile. This is a long awaited feature that allows users to change their profile name to something more suitable for them. This feature is available in the settings menu under the \"Profile\" section.\n"
  },
  {
    "type": "improvement",
    "description": "Timeline now don't break with import anymore. Timezone converted no automatically.\n"
  }
];

export default changes;
